import React from 'react';
import { ClassAssembly8C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8C2026/>;
  };
  
  export default ClassAssemblyPage;